import { fetchDefaultChecklistTemplate } from './fetchDefaultChecklistTemplateThunk';
export default fetchDefaultChecklistTemplate;
